export default __webpack_public_path__ + "static/media/thumbnail1.1acf82ff.jpg";